import { render } from "./TableTooltip.vue?vue&type=template&id=5688d826&ts=true"
import script from "./TableTooltip.vue?vue&type=script&lang=ts"
export * from "./TableTooltip.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__